<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="copy">Text copyright © 2013 by Lerner Publishing Group, Inc.</p>
<p class="copy1">All rights reserved. International copyright secured. No part of this book may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopying, recording, or otherwise—without the prior written permission of Lerner Publishing Group, Inc., except for the inclusion of brief quotations in an acknowledged review.</p>
<p class="copy1">Darby Creek</p>
<p class="copy">A division of Lerner Publishing Group, Inc.</p>
<p class="copy">241 First Avenue North</p>
<p class="copy">Minneapolis, MN 55401 U.S.A.</p>
<p class="copy1">Website address: <a href="http://www.lernerbooks.com" target="_blank">www.lernerbooks.com</a></p>
<p class="copy1">The images in this book are used with the permission of: © <a href="http://iStockphoto.com/StephenMorris" target="_blank">iStockphoto.com/Stephen Morris</a> (fighters); © <a href="http://www.iStockphoto.com/TimMessick" target="_blank">iStockphoto.com/Tim Messick</a> (background); © <a href="http://www.iStockphoto.com/ErkkiMakkonen" target="_blank">iStockphoto.com/Erkki Makkonen</a> (metal wires); © <a href="http://www.iStockphoto.com/TommL" target="_blank">iStockphoto.com/TommL</a> (punching fist), © <a href="http://www.iStockphoto.com/dem10" target="_blank">iStockphoto.com/dem10</a> (barbed wire).</p>
<p class="copy1">Main body text set in Janson Text LT Std 12/17.5.</p>
<p class="copy">Typeface provided by Linotype AG. </p>
<p class="copy2">Library of Congress Cataloging-in-Publication Data</p>
<p class="copy1">Jones, Patrick, 1961–</p>
<p class="copy3">Side control / by Patrick Jones.</p>
<p class="copy4">pages    cm. —   (The dojo ; #2)</p>
<p class="copy3">ISBN 978–1–4677–0631–5 (lib. bdg. : alk. paper)</p>
<p class="copy3">ISBN 978–1–4677–1632–1 (eBook)</p>
<p class="copy3">[1. Mixed martial arts—Fiction. 2. Military service, Voluntary—Fiction.</p>
<p class="copy5">3. African Americans—Fiction.]  I. Title. </p>
<p class="copy5">PZ7.J7242Si  2013</p>
<p class="copy5">[Fic]—dc23</p>
<p class="copyr">2012042250</p>
<p class="copy1">Manufactured in the United States of America</p>
<p class="copy">1 – SB – 7/15/13</p>
<p class="noindentcp1">eISBN: 978-1-4677-1632-1 (pdf)</p>
<p class="noindentcp">eISBN: 978-1-4677-7053-8 (ePub)</p>
<p class="noindentcp">eISBN: 978-1-4677-3301-4 (mobi)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?6132b32c